import React from "react";
import FullRouter from "./RouterPath/index";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./Assets/style/style.css";
import { BrowserRouter } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <FullRouter />
    </BrowserRouter>
  );
}

export default App;
